<template>
  <div class="scheme">
    <div class="scheme-title">敬在智慧管理解决方案</div>
    <div class="scheme-content">
      <div v-for="(scheme, schemeIndex) in schemeList" :key="schemeIndex" class="scheme-item">
        <el-image class="scheme-item-img" :key="scheme.src" :src="scheme.src" lazy></el-image>
        <div class="scheme-item-title">
          <div>{{ scheme.title }}</div>
        </div>
        <div class="scheme-item-info">{{ scheme.info }}</div>
        <div class="scheme-item-btn eno-common-button" @click="toPage(scheme.url)">了解更多</div>
      </div>
    </div>
  </div>
</template>

<script>
import { config } from "../../../constant/config.js";
import { toPage } from '@/utils/index.js'
export default {
  data() {
    return {
      schemeList: config.scheme,
    };
  },
  mounted() { },
  methods: { toPage },
};
</script>

<style lang="less" scoped>
.scheme {
  background-color: @mainGrayColor4;

  .scheme-title {
    background-color: @mainTextColor;
    font-size: 40px;
    line-height: 40px;
    padding: 0 @commonPadding 40px @commonPadding;
  }

  .scheme-content {
    padding: @commonPadding;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-column-gap: 44px;
    grid-row-gap: 100px;

    .scheme-item {
      display: flex;
      flex-direction: column;
      position: relative;
      padding-bottom: 100px;

      .scheme-item-img {
        width: 100%;
      }

      .scheme-item-title {
        margin: 40px 0px;
        font-size: 30px;
      }

      .scheme-item-info {
        color: @mainGrayColor2;
        font-size: 16px;

        display: -webkit-box;
        -webkit-line-clamp: 3;
        /* 固定3行 */
        -webkit-box-orient: vertical;
        overflow: hidden;
        /* 超出部分隐藏 */
        text-overflow: ellipsis;
        /* 超出3行末尾显示省略号 */
      }

      .scheme-item-btn {
        position: absolute;
        bottom: 10px;
        width: 84px;
        height: 38px;
        font-size: 14px;
        padding: 12px;
      }
    }
  }
}

@media @mobile {
  .scheme {
    .scheme-title {
      font-size: @fontSize24;
      padding:20px @commonPadding_h5 20px @commonPadding_h5;
    }

    .scheme-content {
      padding: 36px 36px 0 36px;
      display: block;

      .scheme-item {
        display: flex;
        flex-direction: column;
        padding-bottom:100px;

        .scheme-item-img {
          width: 100%;
        }

        .scheme-item-title {
          margin: 20px 0px;
          font-size: 20px;
        }

        .scheme-item-btn {
          position: absolute;
          bottom:40px;
          width: 84px;
          height: 38px;
          font-size: 14px;
          padding: 12px;
        }
      }
    }
  }
}
</style>
